import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PageNotFoundComponent } from 'project/pages/page-not-found/page-not-found.component';

@NgModule({
  declarations: [PageNotFoundComponent],
  exports: [PageNotFoundComponent],
  imports: [TranslateModule],
})
export class PageNotFoundModule {}
